var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCheckSquare = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42701 11.0733C8.38007 11.0264 8.3164 11 8.25001 11C8.18362 11 8.11995 11.0264 8.07301 11.0733C8.02607 11.1203 7.99969 11.1839 7.99969 11.2503C7.99969 11.3167 8.02607 11.3804 8.07301 11.4273L11.073 14.4273C11.0962 14.4506 11.1238 14.4691 11.1542 14.4817C11.1846 14.4943 11.2171 14.5008 11.25 14.5008C11.2829 14.5008 11.3155 14.4943 11.3458 14.4817C11.3762 14.4691 11.4038 14.4506 11.427 14.4273L22.427 3.42732C22.4503 3.40407 22.4687 3.37648 22.4813 3.34611C22.4939 3.31574 22.5003 3.28319 22.5003 3.25032C22.5003 3.21744 22.4939 3.18489 22.4813 3.15452C22.4687 3.12415 22.4503 3.09656 22.427 3.07332C22.4038 3.05007 22.3762 3.03163 22.3458 3.01905C22.3154 3.00647 22.2829 3 22.25 3C22.2171 3 22.1846 3.00647 22.1542 3.01905C22.1238 3.03163 22.0963 3.05007 22.073 3.07332L11.25 13.8963L8.42701 11.0733Z",
    stroke: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.2504V19.2504C20 19.7145 19.8156 20.1596 19.4874 20.4878C19.1592 20.816 18.7141 21.0004 18.25 21.0004H4.25C3.78587 21.0004 3.34075 20.816 3.01256 20.4878C2.68437 20.1596 2.5 19.7145 2.5 19.2504V5.25037C2.5 4.28437 3.284 3.50037 4.25 3.50037H15.25C15.3163 3.50037 15.3799 3.47403 15.4268 3.42714C15.4737 3.38026 15.5 3.31667 15.5 3.25037C15.5 3.18406 15.4737 3.12047 15.4268 3.07359C15.3799 3.02671 15.3163 3.00037 15.25 3.00037H4.25C3.65326 3.00037 3.08097 3.23742 2.65901 3.65938C2.23705 4.08133 2 4.65363 2 5.25037V19.2504C2 19.8471 2.23705 20.4194 2.65901 20.8414C3.08097 21.2633 3.65326 21.5004 4.25 21.5004H18.25C18.8467 21.5004 19.419 21.2633 19.841 20.8414C20.2629 20.4194 20.5 19.8471 20.5 19.2504V12.2504C20.5 12.1841 20.4737 12.1205 20.4268 12.0736C20.3799 12.0267 20.3163 12.0004 20.25 12.0004C20.1837 12.0004 20.1201 12.0267 20.0732 12.0736C20.0263 12.1205 20 12.1841 20 12.2504Z",
    stroke: props.color || 'currentColor'
  }));
};
export default SvgCheckSquare;